import { WebPubSubClient } from '@azure/web-pubsub-client';
import { v4 as uuidv4 } from 'uuid';
import { get_tripNotes } from './api_utils';

function handle_pubsub_msg(msg:any) {
    const message = msg.message;
    const connectionId = getConnectionId();
    const data = JSON.parse(message.data);

    if (
        connectionId == undefined ||
        connectionId == null ||
        data.initiating_connection == null ||
        data.initiating_connection == undefined

    ) {
        return;
    };


    if (data.initiating_connection != connectionId) {
        if (data.event == "trip_update") {
            window.location.reload();
        } else if (data.event == "notes_update") {
            get_tripNotes().then(notes => {
                for (let i:number = 0; i < window.tripPlannerCurrentTrip.legs.length; i++) {
                    for (let j:number = 0; j < window.tripPlannerCurrentTrip.legs[i].clusters.length; j++) {
                        if (i < notes.l.length && j < notes.l[i].c.length) {
                            window.tripPlannerCurrentTrip.legs[i].clusters[j].notes = notes.l[i].c[j].no;
                            $(`#notes-${i}-${j}`).html(window.tripPlannerCurrentTrip.legs[i].clusters[j].notes);
                        } else {
                            return;
                        }
                    };
                };
            });
        };
    }
}

export function generateConnectionId() {
    const connectionId = uuidv4(); // Use UUID or any other method to generate a unique ID
    sessionStorage.setItem('connectionId', connectionId);
    return connectionId;
}

export function getConnectionId() {
    let connectionId = sessionStorage.getItem('connectionId');
    if (!connectionId) {
        connectionId = generateConnectionId();
    }
    return connectionId;
}

function create_connection():Promise<WebPubSubClient> {
    return new Promise<WebPubSubClient>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: "/pubSubUrl",
            dataType: "json",
            success: async (data) => {
                const client = new WebPubSubClient(data.url);
                resolve(client);
            },
            error: (xhr,errStr,exc) => {
                console.error(errStr)
                reject(new Error(errStr));
            }
        })
    });
};

export async function init_pubsub() {
    const client = await create_connection();
    await client.start();
    client.on("server-message", handle_pubsub_msg);
};

